import React from 'react';

import { FormattedMessage } from 'react-intl';
import { Text } from 'scouting-ui';

import { useGetPersonProfileQuery } from '@modules/rtk/esb-api';

interface YouthLastRankProps {
  /** Scoutbook user id, from the route. */
  userId?: number;
}

/**
 * The "Last Rank ..." line of the youth profile card, rendered into that card's
 * `lastRank` slot so the card stays free of anything rank-shaped.
 *
 * `currentProgramsAndRanks` carries the rank the youth currently holds in each
 * program, so no ranking or filtering is needed. It rides along on the person
 * profile the card is already showing, and RTK Query dedupes by cache key, so
 * asking for it again here costs no extra request.
 */
export default function YouthLastRank(props: YouthLastRankProps) {
  const { userId } = props;

  const { data } = useGetPersonProfileQuery(
    { userId: userId as number },
    { skip: !userId },
  );

  const programs = (data?.currentProgramsAndRanks ?? []).filter(p => !!p.rank);

  return (
    <>
      {programs.map(({ programId, program, rank }) => (
        <Text key={programId}>
          <FormattedMessage
            id="unitRoster.youthProfile.lastRankEarned"
            values={{ program, rank }}
          />
        </Text>
      ))}
    </>
  );
}
